import { cn } from "@/libs/cn";
import { Space } from "antd";

type UserCardProps = {
	index: number;
	user: RoomRequestUser;
	extra?: React.ReactNode;
	containerClassName?: string;
	isInSelectScroll?: boolean;
};

export function UserCard(props: UserCardProps) {
	const {
		user,
		extra,
		index,
		containerClassName,
		isInSelectScroll = false,
	} = props;

	return (
		<section
			className={cn(
				"w-full flex items-center justify-between pb-3 border-b border-gray-100 animate-fade-in",
				containerClassName,
			)}
			title="User Card"
			style={{
				animationDelay: isInSelectScroll ? "0.05s" : `${index * 0.2}s`,
			}}
		>
			<Space align="center" size={"middle"} className="flex-1 ">
				<div className="size-9 aspect-square rounded-full bg-primary-gradient flex items-center justify-center">
					<p className="font-poppins text-white">{index}</p>
				</div>

				<article className="font-poppins">
					<h3>{user.userName}</h3>
					<p className="text-xs text-gray-400">
						Book ID - {user.bookNo}
					</p>
				</article>
			</Space>
			{extra && extra}
		</section>
	);
}
